import { HandoverScaffoldData } from './handover-scaffold-data';
import { MediaData } from './media-data';
import { HandoverIdentifiedRiskData } from './handover-identified-risk-data';
import { SiteDocumentStatusEnum } from '../../enum/site-document-status.enum';
import { StaffSignatureData } from './staff-signature-data';
import { CustomerSignatureData } from './customer-signature-data';
import { DimensionData } from './dimension-data';
import { VariationInstructionData } from './variation-instruction-data';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class VariationData {
  VariationId: string;
  NextInspectionDate: string;
  HandoverId: string;
  VariationType: number;
  RisksIdentified: boolean;
  HandOverType: number;
  Scaffolds: HandoverScaffoldData[];
  VariationComments: string;
  IdentifiedRiskDetails: string;
  Media: { [key: string]: MediaData };
  IdentifiedRisks: { [key: string]: HandoverIdentifiedRiskData };
  HandoverQuestionsAsked: string[];
  When: string;
  DocumentReference: string;
  Status: SiteDocumentStatusEnum;
  SiteId: string;
  CustomerId: string;
  StaffSignature: StaffSignatureData;
  CustomerSignature: CustomerSignatureData;
  Dimensions: { [key: string]: DimensionData };
  VariationInstruction: VariationInstructionData;
  Deleted: boolean;
  LastModified: string;
}


